<template>
  <multiselect-search
    v-model="valueModel"
    :open-prefetch="true"
    :search-url="getSearchUrl"
    :search-options="searchOptions"
  >
    <template #no-options>
      {{ $t("dashboard.team_search_no_options", "Please enter 1 or more characters") }}
    </template>
    <template #no-more-infinite>
      {{ $t("dashboard.team_search_no_more", "No more teams") }}
    </template>
  </multiselect-search>
</template>

<script>
import axios from "axios";
import urls from "@/constants/urls.js";
import MultiselectSearch from "@/components/multiselect-search.vue";

export default {
  components: {
    MultiselectSearch,
  },
  props: {
    value: {
      required: true,
    },
    data: {
      required: true,
    },
    cId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      selectedTeam: null,
      activeTeamRequestId: 0,
    };
  },
  watch: {
    value: {
      handler(val) {
        if (this.selectedTeam && Number(this.selectedTeam.id) === Number(val)) {
          // value just changed because this component emitted it itself via
          // valueModel's setter -- the option is already held, no need to re-fetch it.
          return;
        }

        if (val) {
          this.hydrateSelectedTeam(val);
        } else {
          this.activeTeamRequestId += 1;
          this.selectedTeam = null;
        }
      },
      immediate: true,
    },
  },
  computed: {
    getSearchUrl() {
      const cID = this.cId;
      const orgID = localStorage.getItem("orgId");

      if (Number(cID) === 0) {
        throw new Error("getSearchUrl team multiselect campaign id is 0");
      }

      return urls.apiTeams.replace(":orgId", orgID).replace(":campaignId", cID);
    },

    searchOptions() {
      return {
        placeholder: this.$t("dashboard.multiselect_choose_team", "Choose team"),
        changeParams: ({ query, page, per_page: pp }) => ({
          q: query,
          page: page,
          limit: pp,
        }),
        customLabel: (e) => `[${e.id}] ${e.name}`,
        processResults: (results) =>
          results.map((el) => ({
            id: el.id,
            ...el.attributes,
            $isDisabled: this.data.some((t) => t.team_id === Number(el.id)),
          })),
      };
    },

    valueModel: {
      get() {
        return this.selectedTeam;
      },
      set(val) {
        this.selectedTeam = val;
        this.$emit("input", val ? Number(val.id) : null);
      },
    },
  },
  methods: {
    hydrateSelectedTeam(teamId) {
      this.activeTeamRequestId += 1;
      const requestId = this.activeTeamRequestId;

      axios
        .get(this.getSearchUrl, { params: { team_id: teamId, limit: 1 } })
        .then(({ data }) => {
          // Drop the response if the value changed again while this request was in flight.
          if (requestId !== this.activeTeamRequestId) {
            return;
          }
          const [team] = this.searchOptions.processResults(data.data);
          this.selectedTeam = team || null;
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>
